import BaseInfoBox from "../BaseInfoBox";
import HTPFourthPart from "../HTPFourthPart";

export default class HTPTheWarlock extends BaseInfoBox {
  private HTPFourthPart = HTPFourthPart.getInstance();
  constructor() {
    super();
    this._addCoord();
    this.addBg(260, 160, 0x3ba032, 0x4bb042)
    this.addText("THE WARLOCK COUNTS as A WILD SYMBOL IN BONUS SOUNDS", 80, 240);
    this.addToCon();
    this.scale.set(this.startScale);
    this.visible = false;
  }

  _addCoord(){
    let x = 200;
    let y = -100;
    if (this.isVertical) {
      x = 150;
      y = 335
    }
    this.addCoord(x, y);
  }
  addToCon() {
    this.HTPFourthPart.addChild(this);
  }
}